module.exports = __webpack_public_path__ + "media/images/favicon_16x16-dbe1b1bc35185d0547d144c3c2a85452.png";